import React, { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import ApplicantCard from '../../../../components/Card/ApplicantCard';
import useGetSingleJobApplicants from '../../../../hooks/jobs/useGetSingleJobApplicants';
import { useApplicantsRefresh } from '../../../../context/ApplicantRefreshContext';
import { IApplicantData } from '../../../../models/jobs/singleJobApplicants.model';

interface ApplicantProps {
  jobId: string;
}

const Applicant: React.FC<ApplicantProps> = ({ jobId }) => {
  const { refresh } = useApplicantsRefresh();
  const { getSingleJobApplicant, loading, applicantData } =
    useGetSingleJobApplicants();

  // Load the applicants on mount
  useEffect(() => {
    getSingleJobApplicant(jobId);
  }, [jobId, getSingleJobApplicant, refresh]);

  if (!loading && !applicantData?.length) {
    return <Container>No applicant yet</Container>;
  }

  return (
    <Container>
      {loading ? (
        <LoadingOutlined />
      ) : (
        applicantData?.map((data: IApplicantData, index: number) => (
          <ApplicantCard key={index} {...data} setStatus="SCREENING" />
        ))
      )}
    </Container>
  );
};

export default Applicant;

const Container = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;
